<template>
    <div>

        <div class="panel panel-info">
            <div class="panel-heading">
                <i class="fa fa-table" aria-hidden="true"></i> LOGS DO CLIENTE
            </div>
            <div class="panel-body">

                <table id="mytable" class="table table-bordred table-striped">

                    <thead>
                    <tr>
                        <th>TEXTO</th>
                        <th style="text-align: center;width: 120px">USUÁRIO</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="r in contratos" v-bind:key="r._id">
                        <td>{{r.texto}}</td>
                        <td style="text-align: center">{{r.usuario}}</td>
                    </tr>
                    </tbody>

                </table>

            </div>

        </div>
    </div>
</template>
<script>
import { Contratos } from "../../class/contratos";
import { date } from "../../filters";

export default {
    props: {
        id: {
            default: null
        }
    },
    filters: {
        date
    },
    data() {
        return {
            contratos: [],
            user: null,
            interval: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.$parent.$on("comandos", () => {
            this.loadComandos();
        });
    },
    mounted() {
        this.loadComandos();
        this.interval = setInterval(this.loadComandos, 120000);
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    },
    methods: {
        loadComandos() {
            Contratos.logs(this.id)
                .then(rows => (this.contratos = rows))
                .catch(err => console.log(err));
        }
    }
};
</script>
